import restApi from "./rest.service";
import store from "../stores/store";

const basePath = `${process.env.REACT_APP_API_BASE_URL}/store`;

const startSession = async (name, email) => {
	try {
		const formData = new FormData();
		formData.append("name", name);
		formData.append("email", email);

		const headers = {
			"Content-Type": "multipart/form-data",
		};

		const url = `${basePath}/session`;

		const response = await restApi.post(url, formData, { headers });

		if (response.data?.token) {
			store.dispatch({
				type: "SET_TOKEN",
				payload: response.data?.token,
			});
		} else {
			throw new Error("Token not found");
		}
	} catch (error) {
		console.error("authService.session", "Error creating session", error);
		throw new Error("Error creating session", error);
	}
};

const sessionStarted = () => {
	const token = store.getState().auth.token;
	return token != null && token != "";
};

export const authService = {
	startSession,
	sessionStarted,
};
